import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';


export const sidebarTranslationRef = createTranslationRef({
    id: 'caise.sidebar',
    messages: {
        sidebar: {
            keySuffix: '_en',
            home: 'Home',
            development: 'Development',
            experiments: 'Experiments',
            services: 'Services',
            settings: 'Settings',
        },
    },
});

export const sidebarTranslations = createTranslationResource({
    ref: sidebarTranslationRef,
    translations: {
        pl: () => import('./sidebar-pl'),
    },
});

